import {
	getImageBase64,
	getBackground
	, getThemePic
} from "@/views/home/slidePPT/use/methods"
import {
	pathToBase64,
} from '@/utils'
export default async function (data) {
	const node = data.node;
	const title = node.title;
	const color = data.color;
	const id = Math.random().toString(36).slice(-8);
	const background = await getBackground(data?.customTheme)

	return {
		"id": id,
		"elements": [
			{
				"type": "shape",
				"id": "ALhagR569J",
				"width": 533.4,
				"height": 269.68,
				"left": 438.15,
				"top": 31.830000000000002,
				"viewBox": [
					533.4,
					269.68
				],
				"path": "M 33.71 0 L 499.69 0 Q 533.4 0 533.4 33.71 L 533.4 235.97 Q 533.4 269.68 499.69 269.68 L 33.71 269.68 Q 0 269.68 0 235.97 L 0 33.71 Q 0 0 33.71 0 Z",
				"fill": "rgba(63,63,70,1)",
				"fixedRatio": false,
				"rotate": 0,
				"outline": {
					"color": "#203864",
					"width": 0,
					"style": "solid"
				},
				"text": {
					"content": "<p style=\"text-align: center;\"><span style=\"font-size: 18.37px;font-family: 等线;\">&nbsp;</span></p>",
					"defaultFontName": "Microsoft Yahei",
					"defaultColor": "#333",
					"align": "middle"
				},
				"flipH": false,
				"flipV": false,
				"pathFormula": "roundRect",
				"keypoint": 0.125,
				"groupId": "zSZmN5G5RQ"
			},
			{
				"type": "shape",
				"id": "AEk1ibwChj",
				"width": 533.4,
				"height": 392.96,
				"left": 31.75,
				"top": 31.830000000000002,
				"viewBox": [
					533.4,
					392.96
				],
				"path": "M 49.12 0 L 484.28 0 Q 533.4 0 533.4 49.12 L 533.4 343.84 Q 533.4 392.96 484.28 392.96 L 49.12 392.96 Q 0 392.96 0 343.84 L 0 49.12 Q 0 0 49.12 0 Z",
				"fill": "rgba(63,63,70,1)",
				"fixedRatio": false,
				"rotate": 0,
				"outline": {
					"color": "#203864",
					"width": 0,
					"style": "solid"
				},
				"text": {
					"content": "<p style=\"text-align: center;\"><span style=\"font-size: 18.37px;font-family: 等线;\">&nbsp;</span></p>",
					"defaultFontName": "Microsoft Yahei",
					"defaultColor": "#333",
					"align": "middle"
				},
				"flipH": true,
				"flipV": false,
				"pathFormula": "roundRect",
				"keypoint": 0.125,
				"groupId": "zSZmN5G5RQ"
			},
			{
				"type": "shape",
				"id": "pJgLS2Vqw5",
				"left": 537.8509577030834,
				"top": 223.6374374255065,
				"width": 274.880810488677,
				"height": 198.15256257449343,
				"viewBox": [
					200,
					200
				],
				"path": "M 0 0 L 0 200 L 200 200 Z",
				"fill": "rgba(63,63,70,1)",
				"fixedRatio": false,
				"rotate": 0,
				"flipV": true,
				"groupId": "zSZmN5G5RQ"
			},
			{
				"type": "shape",
				"id": "Jj50G2bPja",
				"width": 12.7,
				"height": 15.41,
				"left": 654.05,
				"top": 293.8,
				"viewBox": [
					12.7,
					15.41
				],
				"path": " M0,0 C0.019849081364829397,0.020259186351706038 0.01624015748031496,0.019687354478875624 0.01583005249343832,0.019442283676234018 C0.007217847769028871,0.017726788057742783 0.00016404199475065617,0.008005646219625772 0,0z",
				"fill": "#ed7d31",
				"fixedRatio": false,
				"rotate": 202,
				"outline": {
					"color": "#203864",
					"width": 0,
					"style": "solid"
				},
				"text": {
					"content": "<p style=\"text-align: center;\"><span style=\"font-size: 18.37px;font-family: 等线;\">&nbsp;</span></p>",
					"defaultFontName": "Microsoft Yahei",
					"defaultColor": "#333",
					"align": "middle"
				},
				"flipH": true,
				"flipV": false,
				"special": true
			},
			{
				"type": "shape",
				"id": "qbxMIoqvJj",
				"width": 16.15,
				"height": 16.15,
				"left": 933.52,
				"top": 50.78,
				"viewBox": [
					200,
					200
				],
				"path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
				"fill": "#ed7d31",
				"fixedRatio": false,
				"rotate": 0,
				"outline": {
					"color": "#203864",
					"width": 0,
					"style": "solid"
				},
				"text": {
					"content": "<p style=\"text-align: center;\"><span style=\"font-size: 18.37px;font-family: 等线;\">&nbsp;</span></p>",
					"defaultFontName": "Microsoft Yahei",
					"defaultColor": "#333",
					"align": "middle"
				},
				"flipH": false,
				"flipV": false
			},
			{
				"type": "shape",
				"id": "7lCaKGVzur",
				"width": 16.15,
				"height": 16.15,
				"left": 933.52,
				"top": 77.7,
				"viewBox": [
					200,
					200
				],
				"path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
				"fill": "#ed7d31",
				"fixedRatio": false,
				"rotate": 0,
				"outline": {
					"color": "#203864",
					"width": 0,
					"style": "solid"
				},
				"text": {
					"content": "<p style=\"text-align: center;\"><span style=\"font-size: 18.37px;font-family: 等线;\">&nbsp;</span></p>",
					"defaultFontName": "Microsoft Yahei",
					"defaultColor": "#333",
					"align": "middle"
				},
				"flipH": false,
				"flipV": false
			},
			{
				"type": "shape",
				"id": "K_79pulyKi",
				"width": 16.15,
				"height": 16.15,
				"left": 933.52,
				"top": 104.62,
				"viewBox": [
					200,
					200
				],
				"path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
				"fill": "#ed7d31",
				"fixedRatio": false,
				"rotate": 0,
				"outline": {
					"color": "#203864",
					"width": 0,
					"style": "solid"
				},
				"text": {
					"content": "<p style=\"text-align: center;\"><span style=\"font-size: 18.37px;font-family: 等线;\">&nbsp;</span></p>",
					"defaultFontName": "Microsoft Yahei",
					"defaultColor": "#333",
					"align": "middle"
				},
				"flipH": false,
				"flipV": false
			},
			{
				"type": "shape",
				"id": "U4Fxq61Glc",
				"width": 38.1,
				"height": 19.05,
				"left": 63.5,
				"top": 381,
				"viewBox": [
					200,
					200
				],
				"path": "M 0 0 L 120 0 L 200 100 L 120 200 L 0 200 L 80 100 L 0 0 Z",
				"fill": "rgba(209,132,59,1)",
				"fixedRatio": false,
				"rotate": 0,
				"outline": {
					"color": "#203864",
					"width": 0,
					"style": "solid"
				},
				"text": {
					"content": "<p style=\"text-align: center;\"><span style=\"font-size: 18.37px;font-family: 等线;\">&nbsp;</span></p>",
					"defaultFontName": "Microsoft Yahei",
					"defaultColor": "#333",
					"align": "middle"
				},
				"flipH": false,
				"flipV": false
			},
			{
				"type": "shape",
				"id": "AQgJoemImO",
				"width": 38.1,
				"height": 19.05,
				"left": 101.6,
				"top": 381,
				"viewBox": [
					200,
					200
				],
				"path": "M 0 0 L 120 0 L 200 100 L 120 200 L 0 200 L 80 100 L 0 0 Z",
				"fill": "rgba(209,132,59,1)",
				"fixedRatio": false,
				"rotate": 0,
				"outline": {
					"color": "#203864",
					"width": 0,
					"style": "solid"
				},
				"text": {
					"content": "<p style=\"text-align: center;\"><span style=\"font-size: 18.37px;font-family: 等线;\">&nbsp;</span></p>",
					"defaultFontName": "Microsoft Yahei",
					"defaultColor": "#333",
					"align": "middle"
				},
				"flipH": false,
				"flipV": false
			},
			{
				"type": "shape",
				"id": "ujv01Rx7ON",
				"width": 38.1,
				"height": 19.05,
				"left": 133.35,
				"top": 381,
				"viewBox": [
					200,
					200
				],
				"path": "M 0 0 L 120 0 L 200 100 L 120 200 L 0 200 L 80 100 L 0 0 Z",
				"fill": "rgba(209,132,59,1)",
				"fixedRatio": false,
				"rotate": 0,
				"outline": {
					"color": "#203864",
					"width": 0,
					"style": "solid"
				},
				"text": {
					"content": "<p style=\"text-align: center;\"><span style=\"font-size: 18.37px;font-family: 等线;\">&nbsp;</span></p>",
					"defaultFontName": "Microsoft Yahei",
					"defaultColor": "#333",
					"align": "middle"
				},
				"flipH": false,
				"flipV": false
			},
			{
				"type": "shape",
				"id": "QUrNWn_xzb",
				"width": 38.1,
				"height": 19.05,
				"left": 165.1,
				"top": 381,
				"viewBox": [
					200,
					200
				],
				"path": "M 0 0 L 120 0 L 200 100 L 120 200 L 0 200 L 80 100 L 0 0 Z",
				"fill": "rgba(209,132,59,1)",
				"fixedRatio": false,
				"rotate": 0,
				"outline": {
					"color": "#203864",
					"width": 0,
					"style": "solid"
				},
				"text": {
					"content": "<p style=\"text-align: center;\"><span style=\"font-size: 18.37px;font-family: 等线;\">&nbsp;</span></p>",
					"defaultFontName": "Microsoft Yahei",
					"defaultColor": "#333",
					"align": "middle"
				},
				"flipH": false,
				"flipV": false
			},
			{
				"type": "text",
				"id": "Wuhsp7Kiik",
				"width": 485.35160905840286,
				"height": 111,
				"left": 63.5,
				"top": 85.775,
				"rotate": 0,
				"defaultFontName": "Microsoft Yahei",
				"defaultColor": "#333333",
				"content": "<p style=\"\"><br class=\"ProseMirror-trailingBreak\"></p><p style=\"\" class=\"\"><strong><span style=\"font-size: 66px;\"><span style=\"color: rgba(240,232,232,1);\">工作总结汇报</span></span></strong></p>",
				"lineHeight": 1,
				"outline": {
					"color": "#000",
					"width": 0,
					"style": "solid"
				},
				"fill": "",
				"vertical": false
			},
			{
				"type": "text",
				"id": "R1AG6rrJSS",
				"width": 357.19,
				"height": 40.40625,
				"left": 58.44,
				"top": 208.37,
				"rotate": 0,
				"defaultFontName": "Microsoft Yahei",
				"defaultColor": "#333333",
				"content": "<p style=\"text-align: justify;\"><span style=\"color: #E8E2D6;font-size: 20.41px;font-family: 汉仪粗简黑简;font-weight: bold;\">总结工作</span><span style=\"color: #E8E2D6;font-size: 20.41px;font-family: 汉仪粗简黑简;font-weight: bold;\">/</span><span style=\"color: #E8E2D6;font-size: 20.41px;font-family: 汉仪粗简黑简;font-weight: bold;\">计划未来</span></p>",
				"lineHeight": 1,
				"outline": {
					"color": "#000",
					"width": 0,
					"style": "solid"
				},
				"fill": "",
				"vertical": false
			},
			{
				"type": "text",
				"id": "TSCnaWCFfG",
				"width": 532.08,
				"height": 68.4375,
				"left": 60.73,
				"top": 242.5,
				"rotate": 0,
				"defaultFontName": "Microsoft Yahei",
				"defaultColor": "#333333",
				"content": "<p style=\"text-align: left;\"><span style=\"color: #E8E2D6;font-size: 2.04px;font-family: 汉仪粗简黑简;letter-spacing: 0px;vertical-align: sub; font-size: smaller;\">There&nbsp;are&nbsp;many&nbsp;variations&nbsp;of&nbsp;passages&nbsp;of&nbsp;Lorem&nbsp;Ipsum&nbsp;available,&nbsp;but&nbsp;the&nbsp;&nbsp;majority&nbsp;have&nbsp;suffered&nbsp;alteration&nbsp;some&nbsp;form,&nbsp;by&nbsp;injected</span><span style=\"color: #E8E2D6;font-size: 2.04px;font-family: 汉仪粗简黑简;letter-spacing: 0px;vertical-align: sub; font-size: smaller;\">humour</span><span style=\"color: #E8E2D6;font-size: 2.04px;font-family: 汉仪粗简黑简;letter-spacing: 0px;vertical-align: sub; font-size: smaller;\">,&nbsp;or</span><span style=\"color: #E8E2D6;font-size: 2.04px;font-family: 汉仪粗简黑简;letter-spacing: 0px;vertical-align: sub; font-size: smaller;\">randomThere</span></p>",
				"lineHeight": 1,
				"outline": {
					"color": "#000",
					"width": 0,
					"style": "solid"
				},
				"fill": "",
				"vertical": false
			},
			{
				"type": "shape",
				"id": "71HzBlnthw",
				"width": 940.89,
				"height": 83.23,
				"left": 29.58,
				"top": 441.2,
				"viewBox": [
					940.89,
					83.23
				],
				"path": "M 10.40375 0 L 930.48625 0 Q 940.89 0 940.89 10.40375 L 940.89 72.82625 Q 940.89 83.23 930.48625 83.23 L 10.40375 83.23 Q 0 83.23 0 72.82625 L 0 10.40375 Q 0 0 10.40375 0 Z",
				"fill": "rgba(176,122,88,1)",
				"fixedRatio": false,
				"rotate": 0,
				"outline": {
					"color": "#203864",
					"width": 0,
					"style": "solid"
				},
				"text": {
					"content": "<p style=\"text-align: center;\"><span style=\"font-size: 18.37px;font-family: 等线;\">&nbsp;</span></p>",
					"defaultFontName": "Microsoft Yahei",
					"defaultColor": "#333",
					"align": "middle"
				},
				"flipH": false,
				"flipV": false,
				"pathFormula": "roundRect",
				"keypoint": 0.125
			},
			{
				"type": "text",
				"id": "4hjccoQxBd",
				"width": 343.33,
				"height": 117.953125,
				"left": 660.4,
				"top": 322.0234375,
				"rotate": 0,
				"defaultFontName": "Microsoft Yahei",
				"defaultColor": "#333333",
				"content": "<p style=\"text-align: justify;\"><span style=\"font-size: 97.96px;font-family: 汉仪粗简黑简;font-weight: bold;\">20XX</span></p>",
				"lineHeight": 1,
				"outline": {
					"color": "#000",
					"width": 0,
					"style": "solid"
				},
				"fill": "",
				"vertical": false,
				"shadow": {
					"h": 2.21,
					"v": 2.21,
					"blur": 4.17,
					"color": "#00000091"
				}
			},
			{
				"type": "shape",
				"id": "sksEci2vwg",
				"width": 15.15,
				"height": 15.15,
				"left": 45.57,
				"top": 475.26,
				"viewBox": [
					200,
					200
				],
				"path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
				"fill": "rgba(63,63,70,1)",
				"fixedRatio": false,
				"rotate": 0,
				"outline": {
					"color": "#203864",
					"width": 0,
					"style": "solid"
				},
				"text": {
					"content": "<p style=\"text-align: center;\"><span style=\"font-size: 18.37px;font-family: 等线;\">&nbsp;</span></p>",
					"defaultFontName": "Microsoft Yahei",
					"defaultColor": "#333",
					"align": "middle"
				},
				"flipH": false,
				"flipV": false
			},
			{
				"type": "shape",
				"id": "TdLCNv19Pb",
				"width": 15.15,
				"height": 15.15,
				"left": 938.44,
				"top": 475.26,
				"viewBox": [
					200,
					200
				],
				"path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
				"fill": "rgba(63,63,70,1)",
				"fixedRatio": false,
				"rotate": 0,
				"outline": {
					"color": "#203864",
					"width": 0,
					"style": "solid"
				},
				"text": {
					"content": "<p style=\"text-align: center;\"><span style=\"font-size: 18.37px;font-family: 等线;\">&nbsp;</span></p>",
					"defaultFontName": "Microsoft Yahei",
					"defaultColor": "#333",
					"align": "middle"
				},
				"flipH": false,
				"flipV": false
			},
			{
				"type": "text",
				"id": "t5BgxJQnG8",
				"width": 716.61,
				"height": 40.375,
				"left": 141.69,
				"top": 467.76,
				"rotate": 0,
				"defaultFontName": "Microsoft Yahei",
				"defaultColor": "#333333",
				"content": "<p style=\"text-align: justify;\"><strong><span style=\"font-size: 18.37px;\"><span style=\"font-family: 汉仪粗简黑简;\"><span style=\"color: #ffffff;\">演讲人：ChatGPT</span></span></span></strong></p>",
				"lineHeight": 1,
				"outline": {
					"color": "#000",
					"width": 0,
					"style": "solid"
				},
				"fill": "",
				"vertical": false
			}
		],
		background
	};

}